<template>
  <v-select label="Tipo de Empaque"
    v-model="selected"
    item-title="packagingType"
    :items="getPackagingTypes" return-object
    :rules="[rules.requiredFieldRule]"
    variant="outlined"
    density="comfortable">
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PackagingTypeSelector',

  props: {
    modelValue: Object
  },

  data: () => ({
    rules: {
      requiredFieldRule: v => ((v !== null) && (typeof v !== 'undefined') && (v !== '') && (v.id > 0)) || 'Campo requerido.'
    }
  }),

  computed: {
    ...mapGetters('typesModule', ['getPackagingTypes']),
    selected: {
      get () { return this.modelValue },
      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  created () {
    this.$store.dispatch('typesModule/getPackagingTypes')
    this.packagingType = this.initialValue
  }
}
</script>
